import { useTranslation } from 'next-i18next'
import styled, { css } from 'styled-components'

import { EEventTypeValue } from '../entities'
import { NookEvent } from '../types'
import { colors } from '../utils'
import { H6 } from './Headings'

interface BadgeProps {
  isGoing: boolean
}
const Badge = styled.div`
  padding: 6px 8px;
  border-radius: 6px;
  h6 {
    color: ${colors.white};
  }
  ${(props: BadgeProps) =>
    props.isGoing
      ? css`
          background: ${colors.green};
        `
      : css`
          background: ${colors.pink};
        `}
`

export const EventTypeBadge: React.FC<{
  event: NookEvent
}> = ({ event, ...props }) => {
  const { t } = useTranslation('common')
  const { event_paid_type, is_user_going } = event

  let label = ''

  if (is_user_going) {
    label = t('going', 'going')
  } else {
    label =
      event_paid_type === EEventTypeValue.FREE
        ? t('free', 'free')
        : t('paid', 'paid')
  }

  return (
    <Badge isGoing={is_user_going} {...props}>
      <H6>{label}</H6>
    </Badge>
  )
}
